import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, tokens } from "@/lib/api";

const AuthContext = createContext(null);

const withSession = ({ tokens: t, ...user }) => {
  if (t) tokens.set(t);
  return user;
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(withSession(data));
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(withSession(data));
  };
  const logout = async () => {
    const ev = new CustomEvent("bb-flush", { detail: { pending: [] } });
    window.dispatchEvent(ev);
    await Promise.allSettled(ev.detail.pending);
    await api.post("/auth/logout").catch(() => {});
    tokens.clear();
    setUser(false);
  };
  const refresh = useCallback(async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  }, []);

  return <AuthContext.Provider value={{ user, setUser, login, register, logout, refresh }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
